import React, { useState, useEffect } from 'react';
import styles from './CheckInRequest.module.css';
import FireboardUtils from "../../../../util/fireboard-util";
import TextInput from '../../../../components/TextInput';
import PopupHeader from '../PopupHeader';
import { CountryPicker, getPickerData } from "../../../../components/CountryPicker";

const US_COUNTRY_CODE = 'us';
const UK_COUNTRY_CODE = 'gb';

export default function CheckInRequest(props) {
    const { invokeCheckIn, selectedItem, fromFooter = false, meta, onClose, currency = '£', iso2 } = props;
    const [phoneNumber, setPhoneNumber] = useState(meta ? FireboardUtils.formattedPhoneNumber(meta.phoneNumber, iso2) : "");
    const [guestName, setGuestName] = useState(meta ? meta.deliverTo : "");
    const [pickupTime, setPickupTime] = useState(meta ? FireboardUtils.getTimeForPickup(meta.pickupDate) : "");
    const [checkNumber, setCheckNumber] = useState(meta ? meta.checkNumber.substr(1, meta.checkNumber.length - 2) : "");
    const [selectedCountry, setSelectedCountry] = useState({});

    useEffect(() => {
        setDefaultCountry();
    }, []);

    const setDefaultCountry = () => {
        const countriesData = getPickerData();
        const countryCode = currency === '£' ? UK_COUNTRY_CODE : US_COUNTRY_CODE;
        const defaultCountry = countriesData.find(country => country.iso2 === countryCode);
        setSelectedCountry(defaultCountry);
    }

    const onCountryChange = country => {
        const formattedPhoneNumber = FireboardUtils.inputFormattedPhnNum(phoneNumber, country.iso2);
        setSelectedCountry(country);
        setPhoneNumber(formattedPhoneNumber);
    };

    useEffect(() => {
        if (Object.keys(selectedItem).length && !fromFooter) {
            const { selectedCheckDetails } = selectedItem || {};
            const { phoneNumber, guestName, pickupDate, checkNumber } = selectedCheckDetails || {};
            setPhoneNumber(!!phoneNumber ? FireboardUtils.formattedPhoneNumber(phoneNumber, iso2) : '');
            setGuestName(!!guestName ? guestName : '');
            setPickupTime(!!pickupDate ? FireboardUtils.getTimeForPickup(pickupDate) : '')
            setCheckNumber(!!checkNumber ? checkNumber : '')
        }

        return function cleanup() {
            reset();
        };
    }, [selectedItem, fromFooter, iso2]);

    const reset = (selectedItem) => {
        const { selectedCheckDetails } = selectedItem || {};
        const { checkNumber } = selectedCheckDetails || {};
        setPhoneNumber('');
        setGuestName('');
        setPickupTime('');
        if (!checkNumber) {
            setCheckNumber('');
        }
        setDefaultCountry();
    }

    const request = () => {
        invokeCheckIn({
            phoneNumber: phoneNumber,
            guestName: guestName,
            pickupTime: pickupTime,
            checkNumber: checkNumber,
            selectedCountry: selectedCountry,
        });
    }

    const changeTime = time => {
        const updatedTime = `${time}:00`;
        setPickupTime(updatedTime);
    }

    const isDisabled = () => {
        if (phoneNumber.length > 0 && checkNumber.length > 0) {
            return false;
        }
        return true;
    }

    const disableCheckNumber = () => {
        return !!(props.selectedItem?.selectedCheckDetails?.checkNumber);
    }

    return (
        <div className={styles.container}>
            <PopupHeader title={"CHECK-IN REQUEST"} onClose={onClose} containerStyle={styles.heading} />
            <div className={styles.container}>
                <div>
                    <label className={styles.label}>Country Code</label>
                    <CountryPicker selectedCountry={selectedCountry} onCountryChange={onCountryChange} />
                </div>
                <TextInput type="tel" placeholder="Phone Number" value={FireboardUtils.inputFormattedPhnNum(phoneNumber, selectedCountry.iso2)} onChange={val => setPhoneNumber(val)} inputStyle={styles.textInput} />
                <TextInput type="text" placeholder="Guest Name" value={guestName} onChange={val => setGuestName(val)} inputStyle={styles.textInput} />
                <TextInput type="time" placeholder="Pickup Time" value={pickupTime} onChange={val => changeTime(val)} inputStyle={styles.textInput} />
                <TextInput type="tel" placeholder="Check Number" disabled={disableCheckNumber()} value={checkNumber} onChange={val => setCheckNumber(val)} inputStyle={styles.textInput} />
            </div>
            <div className={styles.btnWrapper}>
                <button className={styles.btns} onClick={() => reset(selectedItem)}>RESET</button>
                <button className={styles.btns} onClick={request} disabled={isDisabled()} style={{ opacity: isDisabled() ? 0.4 : 1 }}>REQUEST</button>
            </div>
        </div>
    );
};